import Tf from 'types/satellite/TimeFrame'
import TfCollection from 'types/satellite/TimeFrameCollection'

export const getSatelliteTimeFrameList = onClick => {
  const collection = new TfCollection()

  collection.add(new Tf('3 Months', '3 months', 3, onClick))
  collection.add(new Tf('6 Months', '6 months', 6, onClick))
  collection.add(new Tf('9 Months', '9 months', 9, onClick))
  collection.add(new Tf('1 Year', '1 year', 12, onClick))
  collection.add(new Tf('2 Years', '2 years', 24, onClick))
  collection.add(new Tf('3 Years', '3 years', 36, onClick))
  collection.add(new Tf('5 Years', '5 years', 60, onClick))

  return collection
}

export const getMortalityTimeFrameList = onClick => {
  const collection = new TfCollection()

  collection.add(new Tf('1 Day', '1 day', 1, onClick))
  collection.add(new Tf('7 Days', '7 days', 7, onClick))
  collection.add(new Tf('14 Days', '14 days', 14, onClick))
  collection.add(new Tf('30 Days', '30 days', 30, onClick))
  collection.add(new Tf('1 Year', '1 year', 12, onClick))

  return collection
}

export const getTime = (hour, minute) =>
  `${hour !== null && hour < 10 ? `0${hour}` : hour}:${
    minute !== null && minute < 10 ? `0${minute}` : minute
  }`
